import { ErrorMessageContents } from '../../../helpers/hub'
import { ManagementReport } from './types'

export const managementReportFetch = (date: Date) =>
  ({ type: 'managementReports.fetch', payload: date } as const)
export type ManagementReportFetchAction = ReturnType<
  typeof managementReportFetch
>

export const addManagementReport = (managementReport: ManagementReport) =>
  ({ type: 'managementReports.add', payload: managementReport } as const)
export type AddManagementReportAction = ReturnType<typeof addManagementReport>

export const managementReportFetchFail = (error: ErrorMessageContents) =>
  ({
    type: 'managementReports.fetchFail',
    payload: error,
    error: true
  } as const)
export type ManagementReportFetchFailAction = ReturnType<
  typeof managementReportFetchFail
>

export type ManagementReportAction =
  | ManagementReportFetchAction
  | AddManagementReportAction
  | ManagementReportFetchFailAction
